import React, { Component, Fragment } from "react";
import { Alert } from "reactstrap";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Alert color="secondary">
          <h1 className="errorBoundary">
            Something went wrong in this element.
          </h1>
          <h1 className="errorBoundary"> Please contact development team.</h1>
        </Alert>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
